import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import CheckoutMiddleWare from 'yoda-checkout-components/lib/middlewares/CheckoutAnalyticsMiddleware';
import AnalyticsMiddleware from './AnalyticsMiddleware';
import CJAMiddleware from './CJAMiddleware';
import PdpIrisMiddleware from './PdpIrisMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    CommonCJAMiddleware,
    AnalyticsMiddleware,
    CJAMiddleware,
    MiniPDPAnalyticsMiddleware,
    CheckoutMiddleWare,
    PdpIrisMiddleware,
];

export default rootMiddleware;
